import React, { useState, useEffect, useMemo } from 'react';
import './Faq.css';
import { API_URL } from './config';

const Faq = () => {
  const [faqs, setFaqs]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [openId, setOpenId]   = useState(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const res  = await fetch(`${API_URL}/api/faq`);
        const data = await res.json();
        if (res.ok) {
          setFaqs(data.faqs || []);
        } else {
          setError('Failed to load FAQs.');
        }
      } catch {
        setError('Network error. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchFaqs();
  }, []);

  const toggle = (id) => setOpenId(prev => prev === id ? null : id);

  // API already orders by category then display_order, so consecutive same-category
  // rows can just be grouped in a single pass.
  const groupedFaqs = useMemo(() => {
    const groups = [];
    for (const f of faqs) {
      const category = f.category || 'General';
      const last = groups[groups.length - 1];
      if (last && last.category.toLowerCase() === category.toLowerCase()) {
        last.items.push(f);
      } else {
        groups.push({ category, items: [f] });
      }
    }
    return groups;
  }, [faqs]);

  if (loading) return <div className="faq-loading">Loading FAQs…</div>;
  if (error)   return <div className="faq-error">{error}</div>;

  return (
    <div className="faq-container">
      <div className="faq-hero">
        <h1 className="faq-title">Frequently Asked Questions</h1>
        <p className="faq-subtitle">
          Find answers to common questions about CTTA Tamil classes.
        </p>
      </div>

      {faqs.length === 0 ? (
        <p className="faq-empty">No FAQs available yet. Check back soon!</p>
      ) : (
        groupedFaqs.map(group => (
          <div className="faq-category-group" key={group.category}>
            <h2 className="faq-category-heading">{group.category}</h2>
            <div className="faq-list">
              {group.items.map((faq, idx) => {
                const isOpen = openId === faq.id;
                return (
                  <div
                    key={faq.id}
                    className={`faq-item ${isOpen ? 'faq-item-open' : ''}`}
                  >
                    <button
                      className="faq-question"
                      onClick={() => toggle(faq.id)}
                      aria-expanded={isOpen}
                    >
                      <span className="faq-q-num">{idx + 1}</span>
                      <span className="faq-q-text">{faq.question}</span>
                      <span className="faq-chevron">{isOpen ? '▲' : '▼'}</span>
                    </button>
                    {isOpen && (
                      <div className="faq-answer">
                        {faq.answer.split('\n').map((line, i) => (
                          <p key={i}>{line}</p>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Faq;
